module.exports = __webpack_public_path__ + "static/img/shP.cdae58e9.png";